/**
 * @generated SignedSource<<75f4a6435a01086ae711da2ce7995a42>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgenticPlanTool$data = {
  readonly descriptionField: {
    readonly id: string;
    readonly richText: {
      readonly $updatableFragmentSpreads: FragmentRefs<"AgenticPlanTool_richText">;
      readonly adfValue: {
        readonly json: AGG$JSON | null;
      } | null;
    } | null;
  } | null;
  readonly key: string;
  readonly " $fragmentType": "AgenticPlanTool";
};
export type AgenticPlanTool$key = {
  readonly " $data"?: AgenticPlanTool$data;
  readonly " $fragmentSpreads": FragmentRefs<"AgenticPlanTool">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "AgenticPlanTool",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "concreteType": "JiraRichTextField",
      "kind": "LinkedField",
      "name": "descriptionField",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "concreteType": "JiraRichText",
          "kind": "LinkedField",
          "name": "richText",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraADF",
              "kind": "LinkedField",
              "name": "adfValue",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "json"
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "AgenticPlanTool_richText"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "bd6e6d85f6cbc2325233374c4241890f";

export default node;
